module.exports = __webpack_public_path__ + "img/okrtype.3e9f6a38.png";